export const dictionariesModule = {
  state: () => ({
    initialLoadingStatus: 0,
    spaTour: {},
    settingsSpaTour: {},
    healthTour: {},
    nutrition: [],
    nutritionByCategory: {},
    cure: [],
    guestTypes: [],
    genders: [],
    extraServices: {},
    loyaltyPrograms: [],
    roomCategories: [],
    checkoutTime: [],
    steps: [
      {id: 1, name: 'Подбор'},
      {id: 2, name: 'О гостях'},
      {id: 3, name: 'Путевка'},
      {id: 4, name: 'Подтверждение'},
      {id: 5, name: 'Оплата'},
    ],
    categoryIcons: {
      '108': {
        src: require(`@/assets/img/categories-status/izumrud-saphir.svg`),
        alt: 'Изумруд сапфир',
      },
      '109': {
        src: require(`@/assets/img/categories-status/kotedj.svg`),
        alt: 'Котедж',
      },
      '111': {
        src: require(`@/assets/img/categories-status/rubin-izumrud.png`),
        alt: 'Рубин изумруд',
      },
      '112': {
        src: require(`@/assets/img/categories-status/granat.svg`),
        alt: 'Гранат',
      },
      '114': {
        src: require(`@/assets/img/categories-status/granat.svg`),
        alt: 'Гранат',
      },
      '118': {
        src: require(`@/assets/img/categories-status/saphir-rubin-izumrud-yashma.svg`),
        alt: 'Сапфир рубин изумруд яшма',
      },
      '119': {
        src: require(`@/assets/img/categories-status/saphir-ametist.svg`),
        alt: 'Сапфир аметист',
      },
      '121': {
        src: require(`@/assets/img/categories-status/ametist-yashma.svg`),
        alt: 'Аметист яшма',
      },
      '122': {
        src: require(`@/assets/img/categories-status/ametist.svg`),
        alt: 'Аметист',
      },
      '124': {
        src: require(`@/assets/img/categories-status/granat.svg`),
        alt: 'Гранат',
      },
      '126': {
        src: require(`@/assets/img/categories-status/saphir-yashma.svg`),
        alt: 'Сапфир яшма',
      },
      '128': {
        src: require(`@/assets/img/categories-status/corall.svg`),
        alt: 'Коралл',
      },
      // '136': {
      //   к.яр. стандарт
      // },
      // '137': {
      //   к.яр. стандарт
      // },
      // '138': {
      //   к.яр. стандарт
      // },
      // '139': {
      //   к.яр. стандарт
      // },
      // '140': {
      //   к.яр. люкс
      // },
      // '141': {
      //   к.яр.
      // },
      '142': {
        src: require(`@/assets/img/categories-status/almaz.svg`),
        alt: 'Алмаз',
      },
      '143': {
        src: require(`@/assets/img/categories-status/almaz.svg`),
        alt: 'Алмаз',
      },
      '144': {
        src: require(`@/assets/img/categories-status/almaz.svg`),
        alt: 'Алмаз',
      },
      '145': {
        src: require(`@/assets/img/categories-status/kotedj.svg`),
        alt: 'Котедж',
      },
      '146': {
        src: require(`@/assets/img/categories-status/kotedj.svg`),
        alt: 'Котедж',
      },
      // '145': {
      //   src: require(`@/assets/img/categories-status/ametist-saphir.svg`),
      //   alt: 'Аметист сапфир',
      // },
      '150': {
        src: require(`@/assets/img/categories-status/saphir.svg`),
        alt: 'Сапфир',
      },
      '151': {
        src: require(`@/assets/img/categories-status/yashma.svg`),
        alt: 'Яшма',
      },
      // '152': {
        // Аванс за реабилитационно-восстановительное лечение
      // },
      // '153': {
      //   к.яр.
      // },
      '154': {
        src: require(`@/assets/img/categories-status/saphir-ametist.svg`),
        alt: 'Аметист сапфир',
      },
      '155': {
        src: require(`@/assets/img/categories-status/saphir.svg`),
        alt: 'Сапфир',
      },
      '156': {
        src: require(`@/assets/img/categories-status/kotedj.svg`),
        alt: 'Котедж',
      },
      '157': {
        src: require(`@/assets/img/categories-status/eko-house.svg`),
        alt: 'Эко-дом',
      },
    },
    // krasniyYarIds: [
    //   '153',
    //   '136',
    //   '137',
    //   '138',
    //   '139',
    //   '140',
    //   '141',
    //   '156',
    //   '128',
    // ],
    krYarCureIds: [32,33],
  }),

  getters: {
    getNutrition: (state, getters, rootState, rootGetters) => {
      const selectedCat = rootGetters[`selection/getSelectedCategory`]
      const selectedCategoryId = selectedCat ? String(selectedCat.id) : null
      const allowedIds = selectedCategoryId && state.nutritionByCategory
        ? state.nutritionByCategory[selectedCategoryId]
        : null

      return state.nutrition.reduce((acc, obj) => {
        if (Array.isArray(allowedIds) && allowedIds.length > 0) {
          if (allowedIds.findIndex(id => +id === +obj.id) === -1) {
            return acc
          }
        }
        acc.push({
          text: obj.title,
          value: obj.id,
        })
        return acc
      }, [])
    },

    getNutritionById: state => id => {
      return state.nutrition.find(obj => obj.id === id)
    },

    getCureList: (state, getters, rootState, rootGetters) => {
      // TODO: убрать временное решение
      // айди в формате "айди здравницы"|"айди битры" потому что для ключей и яра есть итемы с одинаковыми айди в битре
      let spaCuresIds = [`3`]
      let weightCorrectionCureIds = [30, 32]
      const findInSpaCures = (id) => spaCuresIds.findIndex(el => +id === +el) !== -1
      const findInWeightCorrectionCureIds = (id) => weightCorrectionCureIds.findIndex(el => +id === +el) !== -1
      const findCureInKrYarIds = (id) => state.krYarCureIds.findIndex((el) => +el === +id) !== -1

      let list = state.cure.reduce((acc, cur) => {
        let ids = cur.id.split(`|`) // [0] - zdrav, [1] - bitr
        let tempItem = { ...cur, id: ids[0], btrId: ids[1] }
        if(cur.priceExtension?.adults || cur.priceExtension?.child) acc.push(tempItem)
        return acc
      }, [])

      const selectedCatForCure = rootGetters[`selection/getSelectedCategory`]
      const selectedCategoryId = selectedCatForCure ? String(selectedCatForCure.id) : null
      const ecoHouseCategoryId = `160`
      /* cure at spa (для категории 160 — не режем до СПА, нужен «Биохакинг») */
      if(rootState.selection.isSpaTour && selectedCategoryId !== ecoHouseCategoryId) {
        list = list.filter(cur => findInSpaCures(cur.id))
        return list
      } else {
        list = list.filter(cur => !findInSpaCures(cur.id))
      }
      /* cure at spa end */

      /* cure at health tour (для 160 — не подменяем на программу оздоровительного тура) */
      let cureHealthBxId = state.healthTour.kluchiBxId;

      if(rootState.selection.isHealthTour && selectedCategoryId !== ecoHouseCategoryId) {
        if(+rootGetters[`selection/getSelectedCategory`].divisionId === 2) {
          cureHealthBxId = state.healthTour.krYarBxId
        }

        list = list.filter(cur => +cur.id === +state.healthTour.zdId && +cur.btrId === +cureHealthBxId)
        return list
      }
      /* cure at health tour end */

      /* filter list by division */
      if(+rootGetters[`selection/getSelectedCategory`].divisionId === 2) {
        list = list.filter(item => !findInWeightCorrectionCureIds(item.id) && (+item.id < 32 || +item.id > 51) && findCureInKrYarIds(+item.btrId) )
      } else {
        list = list.filter(item => !findCureInKrYarIds(+item.btrId) )
      }
      /* filter list by division end */

      /* «Биохакинг» (здравница id 59): только для категории номера 160; для остальных категорий не показываем */
      const biohackingZdravId = `59`
      if(selectedCategoryId === ecoHouseCategoryId) {
        list = list.filter(item => String(item.id) === biohackingZdravId)
      } else {
        list = list.filter(item => String(item.id) !== biohackingZdravId)
      }
      return list
    },

    getCureById: (state, getters, rootState) => (id, divisionId = 1) => {
      return state.cure.find(obj => {
        let ids = obj.id.split(`|`)
        let idCompare = +ids[0] === +id
        let btrCompare = false
        if(!rootState.selection.isSpaTour) {
          if(+divisionId === 1) {
            btrCompare = !getters.findCureInKrYarIds(+ids[1])
          } else if (+divisionId === 2) {
            btrCompare = getters.findCureInKrYarIds(+ids[1])
          }
        } else {
          btrCompare = true
        }

        return idCompare && btrCompare
      })
    },

    getGuestTypes: state => {
      return state.guestTypes.reduce((acc, obj) => {
        acc.push({
          text: obj.title,
          value: String(obj.id),
        })
        return acc
      }, [])
    },

    getGuestTypeById: state => id => {
      return state.guestTypes.find(obj => String(obj.id) === id)
    },

    getDefaultGuestType: state => {
      return state.guestTypes.find(obj => obj.default).id
    },

    getExtraServices: state => {
      return state.extraServices
    },

    getLoyaltyPrograms: state => {
      return state.loyaltyPrograms
    },

    getRoomCategoriesById: state => idsArr => {
      return state.roomCategories.filter(obj => idsArr.indexOf(obj.id) !== -1)
    },

    getRoomCategoryById: state => id => {
      return state.roomCategories.find(obj => obj.id === id)
    },

    checkSpaTourAvailable: state => {
      return !!state.spaTour[process.env.VUE_APP_SITE]
    },

    checkHealthTourAvailable: state => {
      return !!state.healthTour[process.env.VUE_APP_SITE]
    },

    getHealthTour: state => {
      return state.healthTour
    },

    findCureInKrYarIds: (state) => (id) => state.krYarCureIds.findIndex((el) => +el === +id) !== -1
  },

  mutations: {
    setInitialLoadingStatus(state, value) {
      state.initialLoadingStatus = value
    },

    setNutrition(state, payload) {
      state.nutrition = payload
    },

    setNutritionByCategory(state, payload) {
      state.nutritionByCategory = payload && typeof payload === 'object' ? payload : {}
    },

    setCure(state, payload) {
      state.cure = payload
    },

    setGuestTypes(state, payload) {
      state.guestTypes = payload
    },

    setGenders(state, payload) {
      state.genders = payload
    },

    setExtraServices(state, payload) {
      state.extraServices = payload
    },

    setLoyaltyPrograms(state, payload) {
      state.loyaltyPrograms = payload
    },

    setRoomCategories(state, payload) {
      state.roomCategories = payload
    },

    setSpaTour(state, payload) {
      state.spaTour = payload
    },

    setHealthTour(state, payload) {
      state.healthTour = payload
    },

    setCheckOutTime(state, payload) {
      state.checkoutTime = payload
    },

    setKrYarCureIds(state, payload) {
      state.krYarCureIds.push(payload);
    },

    setSettingsSpaTour(state, payload) {
      state.settingsSpaTour = payload
    }
  },

  actions: {
    fetchDictionaries({commit, rootState}) {
      commit('setIsLoading', true, { root: true })
      this._vm.$http
        .get('/dictionary/')
        .then(resp => {
          let payload = resp.data.data
          commit('setNutrition', payload.nutrition)
          commit('setNutritionByCategory', payload.nutritionByCategory || {})
          commit('setCure', payload.cure)

          const ageGroup = payload.ageGroup.map(obj => {
            const alias = {
              '0': 'guestAdultCount',
              '1': 'guestChildCount',
              '2': 'guestBabyCount',
            }
            return {
              default: obj.default,
              id: String(obj.id),
              title: obj.title,
              min: obj.default ? 1 : 0,
              alias: alias[obj.id],
            }
          })

          commit('setGuestTypes', ageGroup)

          commit('selection/updateGuests', ageGroup.map(obj => {
            const subtitles = {
              '0': '14 лет и старше',
              '1': 'от 4-х до 13 лет',
              '2': 'до 3-х лет',
            }
            return {
              ...obj,
              value: obj.default ? 1 : 0,
              title: String(obj.id) === '0' ? 'Взрослые' : 'Дети',
              subtitle: subtitles[obj.id],
            }
          }), { root: true })


          commit('setExtraServices', payload.services)
          commit('setSettingsSpaTour', payload.settingsSpaTour)
          payload.services.forEach(item => {
            let finded = rootState.extraServices.list.find(obj => +obj.id === +item.id)
            if(finded) {
              commit(`extraServices/setAvilable`, {name: finded.name, bool: true}, {root: true})
            }
          })

          commit('setLoyaltyPrograms', payload.loyaltyPrograms)
          commit('setRoomCategories', payload.roomCategory)
          commit('setCheckOutTime', payload.checkoutTime)

          commit('selection/setMinDays', +payload.daysMin, { root: true })

          // if(payload.spaTour) commit('setSpaTour', payload.spaTour)
          commit('setSpaTour', payload.spaTour)
          commit('setHealthTour', payload.healthTour)
          commit('setKrYarCureIds', payload.healthTour.krYarBxId)

          commit('setInitialLoadingStatus', 1)
        })
        .catch(e => {
          console.error(e)
          commit('setInitialLoadingStatus', -1)
        })
        .finally(() => {
          commit('setIsLoading', false, { root: true })
        })
    }
  },

  namespaced: true,
}
